const About = {
  name: 'Colorfy',
  link: 'https://www.colorfy.co',
  by: {
    'TrendCycle': 'https://www.trendcycle.co',
  },
  email: 'trendcycle@yahoo.com',
  country: 'Malaysia',
  poweredBy: [
    {
      'React': 'https://reactjs.org',
    },
    {
      'Ant Design': 'https://ant.design',
    },
  ],
}

export default About
